import { EOFExceptionh831u25jcq9n as EOFException } from './-PlatformJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  subtract2orl8z9upxd9l as subtract,
  add2suhfggl4zvkk as add,
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { toShort36kaw0zjdq3ex as toShort } from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  checkBoundsw7d8y6z7j2xc as checkBounds,
  checkOffsetAndCountazlu23xkuwoi as checkOffsetAndCount,
  get_HEX_DIGIT_CHARS28oau3fmf5vf6 as get_HEX_DIGIT_CHARS,
} from './-Util.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isEmpty39cntv762vey6 as isEmpty } from './Segment.mjs';
import { PeekSource3frbthc9yehpr as PeekSource } from './PeekSource.mjs';
import { buffered3kq86cdmguv3h as buffered } from './Core.mjs';
import { SegmentPool_instancep7dfbo63nk35 as SegmentPool_instance } from './SegmentPool.mjs';
import {
  write$default385fuvmpsl23h as write$default,
  Sink189iybvk4puo6 as Sink,
} from './Sink.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  UnsafeBufferOperations_instance13tvuha6xx6us as UnsafeBufferOperations_instance,
  get_SegmentReadContextImpl28xxxurlbcmul as get_SegmentReadContextImpl,
} from './unsafe/UnsafeBufferOperations.mjs';
import { _Char___init__impl__6a9atx1csff5kwtduxl as _Char___init__impl__6a9atx } from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Source1shr0ps16u4p4 as Source } from './Source.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function throwEof($this, byteCount) {
  throw EOFException().m4e("Buffer doesn't contain required number of bytes (size: " + $this.v2().toString() + ', required: ' + byteCount.toString() + ')');
}
var BufferClass;
function Buffer() {
  if (BufferClass === VOID) {
    class $ {
      constructor() {
        this.g4e_1 = null;
        this.h4e_1 = null;
        this.i4e_1 = 0n;
      }
      v2() {
        return this.i4e_1;
      }
      n3x() {
        return this;
      }
      o3x() {
        return this.v2() === 0n;
      }
      p3x(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().s2(toString(message));
        }
        if (this.v2() < byteCount) {
          throw EOFException().m4e("Buffer doesn't contain required number of bytes (size: " + this.v2().toString() + ', required: ' + byteCount.toString() + ')');
        }
      }
      u3x(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount: ' + byteCount.toString() + ' < 0';
          throw IllegalArgumentException().s2(toString(message));
        }
        return this.v2() >= byteCount;
      }
      x3x() {
        var tmp0_elvis_lhs = this.g4e_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwEof(this, 1n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var segment = tmp;
        var segmentSize = segment.v2();
        if (segmentSize === 0) {
          this.u4e();
          return this.x3x();
        }
        var v = segment.v4e();
        this.i4e_1 = subtract(this.i4e_1, 1n);
        if (segmentSize === 1) {
          this.u4e();
        }
        return v;
      }
      w4e() {
        var tmp0_elvis_lhs = this.g4e_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwEof(this, 2n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var segment = tmp;
        var segmentSize = segment.v2();
        if (segmentSize < 2) {
          this.p3x(2n);
          if (segmentSize === 0) {
            this.u4e();
            return this.w4e();
          }
          // Inline function 'kotlinx.io.and' call
          var tmp_0 = (this.x3x() & 255) << 8;
          // Inline function 'kotlinx.io.and' call
          var tmp$ret$1 = this.x3x() & 255;
          return toShort(tmp_0 | tmp$ret$1);
        }
        var v = segment.x4e();
        this.i4e_1 = subtract(this.i4e_1, 2n);
        if (segmentSize === 2) {
          this.u4e();
        }
        return v;
      }
      y4e() {
        return Unit_instance;
      }
      z4e(out, startIndex, endIndex) {
        checkBounds(this.v2(), startIndex, endIndex);
        if (startIndex === endIndex)
          return Unit_instance;
        var currentOffset = startIndex;
        var remainingByteCount = subtract(endIndex, startIndex);
        out.i4e_1 = add(out.i4e_1, remainingByteCount);
        var s = this.g4e_1;
        while (currentOffset >= fromInt(ensureNotNull(s).p4e_1 - s.o4e_1 | 0)) {
          currentOffset = subtract(currentOffset, fromInt(s.p4e_1 - s.o4e_1 | 0));
          s = s.s4e_1;
        }
        while (remainingByteCount > 0n) {
          var copy = ensureNotNull(s).a4f();
          copy.o4e_1 = copy.o4e_1 + convertToInt(currentOffset) | 0;
          var tmp = copy;
          var tmp0 = copy.o4e_1 + convertToInt(remainingByteCount) | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = copy.p4e_1;
          tmp.p4e_1 = Math.min(tmp0, b);
          // Inline function 'kotlinx.io.Buffer.pushSegment' call
          if (out.g4e_1 == null) {
            out.g4e_1 = copy;
            out.h4e_1 = copy;
          } else if (false) {
            out.h4e_1 = ensureNotNull(out.h4e_1).b4f(copy).c4f();
            if (ensureNotNull(out.h4e_1).t4e_1 == null) {
              out.g4e_1 = out.h4e_1;
            }
          } else {
            out.h4e_1 = ensureNotNull(out.h4e_1).b4f(copy);
          }
          remainingByteCount = subtract(remainingByteCount, fromInt(copy.p4e_1 - copy.o4e_1 | 0));
          currentOffset = 0n;
          s = s.s4e_1;
        }
      }
      d4f() {
        var result = this.v2();
        if (result === 0n)
          return 0n;
        var tail = ensureNotNull(this.h4e_1);
        if (tail.p4e_1 < 8192 && tail.r4e_1) {
          result = subtract(result, fromInt(tail.p4e_1 - tail.o4e_1 | 0));
        }
        return result;
      }
      k3w(position) {
        if (position < 0n || position >= this.v2()) {
          throw IndexOutOfBoundsException().n3('position (' + position.toString() + ') is not within the range [0..size(' + this.v2().toString() + '))');
        }
        if (position === 0n) {
          return ensureNotNull(this.g4e_1).e4f(0);
        }
        // Inline function 'kotlinx.io.seek' call
        if (this.g4e_1 == null) {
          return ensureNotNull(null).e4f(convertToInt(subtract(position, -1n)));
        }
        if (subtract(this.v2(), position) < position) {
          var s = this.h4e_1;
          var offset = this.v2();
          $l$loop: while (!(s == null) && offset > position) {
            offset = subtract(offset, fromInt(s.p4e_1 - s.o4e_1 | 0));
            if (offset <= position)
              break $l$loop;
            s = s.t4e_1;
          }
          var tmp0 = s;
          var offset_0 = offset;
          return ensureNotNull(tmp0).e4f(convertToInt(subtract(position, offset_0)));
        } else {
          var s_0 = this.g4e_1;
          var offset_1 = 0n;
          $l$loop_0: while (!(s_0 == null)) {
            var tmp0_0 = offset_1;
            // Inline function 'kotlin.Long.plus' call
            var other = s_0.p4e_1 - s_0.o4e_1 | 0;
            var nextOffset = add(tmp0_0, fromInt(other));
            if (nextOffset > position)
              break $l$loop_0;
            s_0 = s_0.s4e_1;
            offset_1 = nextOffset;
          }
          var tmp0_1 = s_0;
          var offset_2 = offset_1;
          return ensureNotNull(tmp0_1).e4f(convertToInt(subtract(position, offset_2)));
        }
      }
      f5() {
        return this.y3u(this.v2());
      }
      y3u(byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().s2(toString(message));
        }
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          var tmp0_elvis_lhs = this.g4e_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw EOFException().m4e('Buffer exhausted before skipping ' + byteCount.toString() + ' bytes.');
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var head = tmp;
          var tmp0 = remainingByteCount;
          // Inline function 'kotlinx.io.minOf' call
          var b = head.p4e_1 - head.o4e_1 | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b_0 = fromInt(b);
          var tmp$ret$4 = tmp0 <= b_0 ? tmp0 : b_0;
          var toSkip = convertToInt(tmp$ret$4);
          this.i4e_1 = subtract(this.i4e_1, fromInt(toSkip));
          remainingByteCount = subtract(remainingByteCount, fromInt(toSkip));
          head.o4e_1 = head.o4e_1 + toSkip | 0;
          if (head.o4e_1 === head.p4e_1) {
            this.u4e();
          }
        }
      }
      f4f(sink, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = sink.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        var tmp0_elvis_lhs = this.g4e_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return -1;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var s = tmp;
        var tmp0 = endIndex - startIndex | 0;
        // Inline function 'kotlin.comparisons.minOf' call
        var b = s.v2();
        var toCopy = Math.min(tmp0, b);
        s.g4f(sink, startIndex, startIndex + toCopy | 0);
        this.i4e_1 = subtract(this.i4e_1, fromInt(toCopy));
        if (isEmpty(s)) {
          this.u4e();
        }
        return toCopy;
      }
      h4f(sink, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().s2(toString(message));
        }
        if (this.v2() === 0n)
          return -1n;
        var bytesWritten = byteCount > this.v2() ? this.v2() : byteCount;
        sink.i4f(this, bytesWritten);
        return bytesWritten;
      }
      j4f(sink, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().s2(toString(message));
        }
        if (this.v2() < byteCount) {
          sink.i4f(this, this.v2());
          throw EOFException().m4e('Buffer exhausted before writing ' + byteCount.toString() + ' bytes. Only ' + this.v2().toString() + ' bytes were written.');
        }
        sink.i4f(this, byteCount);
      }
      k4f(sink) {
        var byteCount = this.v2();
        if (byteCount > 0n) {
          sink.i4f(this, byteCount);
        }
        return byteCount;
      }
      s3z() {
        return buffered(new (PeekSource())(this));
      }
      l4f(minimumCapacity) {
        // Inline function 'kotlin.require' call
        if (!(minimumCapacity >= 1 && minimumCapacity <= 8192)) {
          var message = 'unexpected capacity (' + minimumCapacity + '), should be in range [1, 8192]';
          throw IllegalArgumentException().s2(toString(message));
        }
        if (this.h4e_1 == null) {
          var result = SegmentPool_instance.b3w();
          this.g4e_1 = result;
          this.h4e_1 = result;
          return result;
        }
        var t = ensureNotNull(this.h4e_1);
        if ((t.p4e_1 + minimumCapacity | 0) > 8192 || !t.r4e_1) {
          var newTail = t.b4f(SegmentPool_instance.b3w());
          this.h4e_1 = newTail;
          return newTail;
        }
        return t;
      }
      o4f(source, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = source.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        var currentOffset = startIndex;
        while (currentOffset < endIndex) {
          var tail = this.l4f(1);
          var tmp0 = endIndex - currentOffset | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = tail.p4f();
          var toCopy = Math.min(tmp0, b);
          tail.q4f(source, currentOffset, currentOffset + toCopy | 0);
          currentOffset = currentOffset + toCopy | 0;
        }
        var tmp = this;
        var tmp0_0 = this.i4e_1;
        // Inline function 'kotlin.Long.plus' call
        var other = endIndex - startIndex | 0;
        tmp.i4e_1 = add(tmp0_0, fromInt(other));
      }
      i4f(source, byteCount) {
        // Inline function 'kotlin.require' call
        if (!!(source === this)) {
          var message = 'source == this';
          throw IllegalArgumentException().s2(toString(message));
        }
        checkOffsetAndCount(source.i4e_1, 0n, byteCount);
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          if (remainingByteCount < fromInt(ensureNotNull(source.g4e_1).v2())) {
            var tail = this.h4e_1;
            var tmp;
            if (!(tail == null) && tail.r4e_1) {
              var tmp0 = remainingByteCount;
              // Inline function 'kotlin.Long.plus' call
              var other = tail.p4e_1;
              var tmp0_0 = add(tmp0, fromInt(other));
              // Inline function 'kotlin.Long.minus' call
              var other_0 = tail.s4f() ? 0 : tail.o4e_1;
              tmp = subtract(tmp0_0, fromInt(other_0)) <= 8192n;
            } else {
              tmp = false;
            }
            if (tmp) {
              ensureNotNull(source.g4e_1).u4f(tail, convertToInt(remainingByteCount));
              source.i4e_1 = subtract(source.i4e_1, remainingByteCount);
              this.i4e_1 = add(this.i4e_1, remainingByteCount);
              return Unit_instance;
            } else {
              source.g4e_1 = ensureNotNull(source.g4e_1).t4f(convertToInt(remainingByteCount));
            }
          }
          var segmentToMove = ensureNotNull(source.g4e_1);
          var movedByteCount = fromInt(segmentToMove.v2());
          source.g4e_1 = segmentToMove.v4f();
          if (source.g4e_1 == null) {
            source.h4e_1 = null;
          }
          // Inline function 'kotlinx.io.Buffer.pushSegment' call
          if (this.g4e_1 == null) {
            this.g4e_1 = segmentToMove;
            this.h4e_1 = segmentToMove;
          } else if (true) {
            this.h4e_1 = ensureNotNull(this.h4e_1).b4f(segmentToMove).c4f();
            if (ensureNotNull(this.h4e_1).t4e_1 == null) {
              this.g4e_1 = this.h4e_1;
            }
          } else {
            this.h4e_1 = ensureNotNull(this.h4e_1).b4f(segmentToMove);
          }
          source.i4e_1 = subtract(source.i4e_1, movedByteCount);
          this.i4e_1 = add(this.i4e_1, movedByteCount);
          remainingByteCount = subtract(remainingByteCount, movedByteCount);
        }
      }
      w4f(source) {
        var totalBytesRead = 0n;
        $l$loop: while (true) {
          var readCount = source.h4f(this, 8192n);
          if (readCount === -1n)
            break $l$loop;
          totalBytesRead = add(totalBytesRead, readCount);
        }
        return totalBytesRead;
      }
      x4f(byte) {
        this.l4f(1).y4f(byte);
        this.i4e_1 = add(this.i4e_1, 1n);
      }
      z4f(short) {
        this.l4f(2).a4g(short);
        this.i4e_1 = add(this.i4e_1, 2n);
      }
      q6() {
        return Unit_instance;
      }
      toString() {
        if (this.v2() === 0n)
          return 'Buffer(size=0)';
        var maxPrintableBytes = 64;
        // Inline function 'kotlinx.io.minOf' call
        var b = this.v2();
        // Inline function 'kotlin.comparisons.minOf' call
        var a = fromInt(maxPrintableBytes);
        var tmp$ret$1 = a <= b ? a : b;
        var len = convertToInt(tmp$ret$1);
        var builder = StringBuilder().yb(imul(len, 2) + (this.v2() > fromInt(maxPrintableBytes) ? 1 : 0) | 0);
        var bytesWritten = 0;
        // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.forEachSegment' call
        var curr = this.g4e_1;
        while (!(curr == null)) {
          var tmp0 = get_SegmentReadContextImpl();
          var segment = curr;
          var idx = 0;
          while (bytesWritten < len && idx < segment.v2()) {
            var _unary__edvuaz = idx;
            idx = _unary__edvuaz + 1 | 0;
            var b_0 = tmp0.b4g(segment, _unary__edvuaz);
            bytesWritten = bytesWritten + 1 | 0;
            var tmp = get_HEX_DIGIT_CHARS();
            // Inline function 'kotlinx.io.shr' call
            var tmp$ret$2 = b_0 >> 4;
            var tmp_0 = builder.t1(tmp[tmp$ret$2 & 15]);
            var tmp_1 = get_HEX_DIGIT_CHARS();
            // Inline function 'kotlinx.io.and' call
            var tmp$ret$3 = b_0 & 15;
            tmp_0.t1(tmp_1[tmp$ret$3]);
          }
          curr = curr.s4e_1;
        }
        if (this.v2() > fromInt(maxPrintableBytes)) {
          builder.t1(_Char___init__impl__6a9atx(8230));
        }
        return 'Buffer(size=' + this.v2().toString() + ' hex=' + builder.toString() + ')';
      }
      u4e() {
        var oldHead = ensureNotNull(this.g4e_1);
        var nextHead = oldHead.s4e_1;
        this.g4e_1 = nextHead;
        if (nextHead == null) {
          this.h4e_1 = null;
        } else {
          nextHead.t4e_1 = null;
        }
        oldHead.s4e_1 = null;
        SegmentPool_instance.c4g(oldHead);
      }
      d4g() {
        var oldTail = ensureNotNull(this.h4e_1);
        var newTail = oldTail.t4e_1;
        this.h4e_1 = newTail;
        if (newTail == null) {
          this.g4e_1 = null;
        } else {
          newTail.s4e_1 = null;
        }
        oldTail.t4e_1 = null;
        SegmentPool_instance.c4g(oldTail);
      }
    }
    protoOf($).r4f = write$default;
    initMetadataForClass($, 'Buffer', Buffer, VOID, [Source(), Sink()]);
    BufferClass = $;
  }
  return BufferClass;
}
//region block: exports
export {
  Buffer as Buffergs925ekssbch,
};
//endregion

//# sourceMappingURL=Buffer.mjs.map
